import { name, optionName } from '@/util/container';
import { NormalizedCacheObject } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { KeycloakInstance } from 'keycloak-js';
import { VueConstructor } from 'vue';
import Router, { RouteConfig } from 'vue-router';
import { App, DeviceRole, Manufacturer } from '../model';
import { RootStore } from '../store';

export const CONTAINER = Symbol('CONTAINER');

export const ROUTES = optionName<RouteConfig[]>('ROUTES');
export const APPS = optionName<App>('APPS');
export const DEVICE_ROLES = optionName<DeviceRole>('DEVICE_ROLES');
export const MANUFACTURERS = optionName<Manufacturer>('MANUFACTURERS');

export const VUE = name<VueConstructor>('VUE');
export const ROOT_COMPONENT = name<VueConstructor>('ROOT_COMPONENT');
export const ROUTER = name<Router>('ROUTER');
export const STORE = name<RootStore>('STORE');
export const KEYCLOAK = name<KeycloakInstance>('KEYCLOAK');
export const API_CLIENT = name<ApolloClient<NormalizedCacheObject>>('API_CLIENT');
export const CONSUMPTION_API_REST_CLIENT = Symbol('CONSUMPTION_API_REST_CLIENT');
export const GENERIC_NOTIFICATION_API_REST_CLIENT = Symbol('GENERIC_NOTIFICATION_API_REST_CLIENT');
export const APP_MAP = name<Record<string, App>>('APP_MAP');
export const DEVICE_ROLE_MAP = name<Record<string, DeviceRole>>('DEVICE_ROLE_MAP');
export const MANUFACTURER_MAP = name<Record<string, Manufacturer>>('MANUFACTURER_MAP');
export const API_HEATING_SYSTEM_COLLECTOR_CLIENT = name<ApolloClient<NormalizedCacheObject>>(
  'API_HEATING_SYSTEM_COLLECTOR_CLIENT',
);

export const XLS_IMPORTER = Symbol('XLS_IMPORTER');
export const OBJECT_LIST_MAPPER = Symbol('OBJECT_LIST_MAPPER');
